import { render } from "./PropertyView.vue?vue&type=template&id=9af901f0&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"

import "./PropertyView.vue?vue&type=style&index=0&id=9af901f0&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af901f0"]])

export default __exports__